import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import {ManipulatorService} from '../services/manipulator.service';
import {AuthenticatorService} from '../services/authenticator.service';
import {AuthGuardService} from '../services/auth-guard.service';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ SidebarComponent ],
    exports: [ SidebarComponent ],
    providers: [AuthenticatorService, AuthGuardService]
})

export class SidebarModule {

}
